import { api } from '@/lib/http-client';
import type {
  MetaAdsStatus,
  MetaAdsSyncResult,
  MetaAdsTestResult,
  SaveMetaAdsRequest,
  TestMetaAdsRequest,
} from '@/types/meta-ads';

/**
 * Módulo 11 — Meta Ads (`docs/ADS.md` → tag `MetaAds` del openapi).
 *
 * Reglas que respeta tal cual:
 *  - el token solo se manda al guardar: el backend nunca lo devuelve (solo `tokenConfigurado`);
 *  - guardar, probar y sincronizar es solo ADMIN (un AGENTE_HUMANO recibe 403);
 *  - sincronizar y probar SIEMPRE responden 200: el desenlace viaja en `{ ok, mensaje }` (un fallo de
 *    token o de permisos es información para el panel, no un error de la petición).
 */

export function fetchMetaAdsStatus(tenantId: string): Promise<MetaAdsStatus> {
  return api.get<MetaAdsStatus>(`/api/tenants/${tenantId}/meta-ads`);
}

export function saveMetaAdsConfig(
  tenantId: string,
  payload: SaveMetaAdsRequest,
): Promise<MetaAdsStatus> {
  return api.put<MetaAdsStatus>(`/api/tenants/${tenantId}/meta-ads`, payload);
}

export function syncMetaAds(tenantId: string, payload: { dias?: number } = {}): Promise<MetaAdsSyncResult> {
  return api.post<MetaAdsSyncResult>(`/api/tenants/${tenantId}/meta-ads/sync`, payload);
}

/**
 * «Probar credenciales»: diagnóstico de la cuenta publicitaria y del token (el `#200` de Meta) sin
 * guardar nada. Acepta lo que esté escrito en el formulario para poder probar antes de guardar.
 */
export function testMetaAdsConfig(
  tenantId: string,
  payload: TestMetaAdsRequest = {},
): Promise<MetaAdsTestResult> {
  return api.post<MetaAdsTestResult>(`/api/tenants/${tenantId}/meta-ads/test`, payload);
}
